import Header from "../components/Header";
import Footer from "../components/Footer";
import { Container, Typography } from "@mui/material";
import Flexbox from "../components/Flexbox";
import Spacebox from "../components/Spacebox";
import { isMobile } from "react-device-detect";

const Careers = ({ title }) => {

    document.querySelector('title').innerHTMl = title

    return (
        <div className="careers-page">
            <Header />
            <section>
                <Flexbox justifyContent="center" alignItems="center">
                    <Container>
                        <Spacebox padding="20px" />
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                            Join Our Team
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                            Help businesses grow and achieve their financial goals.
                        </Typography>
                        <Spacebox padding="50px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                            No Available positions at this time
                        </Typography>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                    </Container>
                </Flexbox>
            </section>
            <Footer />
        </div>
    );
}

export default Careers;